export default class MultipleCheckboxToggle {
  constructor(el) {
    this.el = el;
    this.boxesParent = this.el.getAttribute('data-boxes-wrapper');
    this.el.addEventListener(
      'click',
      e => {
        if (e.target.checked) {
          $(this.boxesParent)
            .find('input[type=checkbox]')
            .prop('checked', true);
        } else {
          $(this.boxesParent)
            .find('input[type=checkbox]')
            .prop('checked', false);
        }
      },
      false
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/multiple_checkbox_toggle.js